<template>
  <section class="px-6">
    <h2 class="mt-10">
      Оюутны бүртгэл (<span v-if="selectedStudents2">{{
        selectedStudents2.length
      }}</span
      >)
    </h2>

    <v-row v-if="_isXAdmin(userProfile)">
      <v-col cols="12" sm="3" md="3" lg="3">
        <v-select
          v-if="xprofessions"
          v-model="selectedProfession"
          :items="xprofessions"
          label="Мэргэжил"
          return-object
          item-text="name2"
          item-value="id"
          clearable
        >
        </v-select>
        <!-- <v-btn
                v-if="selectedProfession != null"
                color="blue"
                class="pa-0 ml-4"
                dark
                elevation="0"
                text
                @click="selectedProfession = null"
                >Clear</v-btn
              > -->

        <!-- <v-btn
          color="red"
          class="pa-0 ml-4"
          dark
          elevation="0"
          text
          @click="_increaseClasses(null)"
          >Анги дэвшүүл</v-btn
        > -->
      </v-col>
      <v-col
        cols="12"
        sm="3"
        md="3"
        lg="3"
        v-if="xClassGroups && xClassGroups.length > 0"
      >
        <v-select
          v-model="filteredSelectedClassGroup"
          :items="xClassGroups"
          label="Анги"
          return-object
          item-text="name2"
          item-value="id"
          clearable
        >
        </v-select>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" v-if="filteredSelectedClassGroup">
        <v-select
          v-model="filteredSelectedClassGroupProgram"
          :items="filteredSelectedClassGroup.programs"
          return-object
          item-text="name2"
          item-value="id"
          label="Ангийн дугаар"
          clearable
        >
        </v-select>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="text-end">
        <v-row align="center" justify="space-between">
          <v-col cols="12" md="6" lg="6">
            <v-text-field
              @input="handleInputChange"
              v-model="search"
              append-icon="mdi-magnify"
              label="Xайx"
              clearable
            ></v-text-field>
          </v-col>
          <!-- <v-btn
                color="gray"
                elevation="0"
                class="mb-2 pa-0"
                @click="_deleteAll(school)"
                title="Бөнөөр нэмэx"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn> -->
          <v-col cols="12" md="6" lg="6" class="text-end">
            <v-btn
              small
              color="gray"
              elevation="0"
              class="mb-2 pa-0"
              @click="_newBulkDialog(null)"
              title="Бөнөөр нэмэx"
            >
              <v-icon>mdi-animation</v-icon>
            </v-btn>
            <v-btn
              small
              color="secondary"
              elevation="0"
              class="mb-2"
              @click="_newDialog(null)"
              title="Шинээр нэмэx"
            >
              <v-icon>mdi-playlist-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-progress-linear
      v-if="loading"
      height="5"
      indeterminate
      color="red"
    ></v-progress-linear>
    <material-card
      icon="mdi-clipboard-text"
      icon-small
      color="accent"
      v-if="items && items.length > 0"
    >
      <!-- <v-btn @click="_changeAll">change All</v-btn> -->

      <v-row class="mx-4">
        <v-col class="d-flex flex-row">
          <v-btn icon class="mt-n2 ml-10" @click="callPages(-1)">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h3>
            {{ currentPageNumber }}
          </h3>
          <v-btn icon class="mt-n2" @click="callPages(1)">
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>

        <v-spacer></v-spacer>

        <!-- <v-col cols="auto" @click="_setState()">
          <v-btn>xxx </v-btn>
        </v-col> -->
        <v-col cols="auto">
          <v-select
            label="Төлөв"
            v-model="filterState"
            :items="[
              { name: 'Суралцаж байгаа', code: 1 },
              { name: 'Чөлөө авсан', code: 2 },
              { name: 'Сургуулиас шилжсэн', code: 3 },
              { name: 'Сургуулиас чөлөөлөгдсөн', code: 4 },
              { name: 'Төгссөн', code: 6 },
            ]"
            return-object
            clearable
            item-text="name"
            item-value="code"
          ></v-select>
        </v-col>
        <!-- <v-col cols="auto">
          <v-checkbox label="Төгссөн" v-model="isStudied"></v-checkbox>
        </v-col> -->
        <v-col cols="auto">
          <v-checkbox
            label="Тодорxойгүй"
            v-model="isStudyingUndefined"
          ></v-checkbox>
        </v-col>
        <!-- <v-col cols="auto">
          <v-checkbox
            label="Суралцаж байгаа оюутнууд"
            v-model="isStudying"
          ></v-checkbox>
        </v-col> -->
      </v-row>

      <v-data-table
        :headers="headers"
        :items="selectedStudents2"
        :search="search"
        :items-per-page="-1"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td
              @click="_printStudent(props.item)"
              :style="
                props.item[
                  'xClassGroupProgramRef-' +
                    userProfile.school.currentSemesterYears +
                    '-1'
                ]
                  ? 'background-color: greenyellow'
                  : props.item['classIncreased-ERROR-NO-DEP']
                  ? 'background-color: red; color:white'
                  : ''
              "
            >
              {{ props.item.index }}
              <v-btn small @click="_increaseStudent(props.item)">Дэв</v-btn>
            </td>
            <td>{{ props.item.studentCode }}</td>
            <td>{{ props.item.firstName }}</td>
            <td>{{ props.item.lastName }}</td>
            <td>
              <span v-if="props.item.school" class="font-weight-bold">
                <span
                  v-if="props.item.school.schoolIndex == 1"
                  class="red--text"
                  >{{ props.item.school.shortName.toUpperCase() }}</span
                >
                <span
                  v-if="props.item.school.schoolIndex == 2"
                  class="blue--text"
                  >{{ props.item.school.shortName.toUpperCase() }}</span
                >
              </span>
              <span v-else class="red-text">?</span>
            </td>
            <td>{{ props.item.register }}</td>
            <!-- <td v-if="userProfile.email == 'granditxxk@gmail.com'">
              {{ props.item.ref.path }}
            </td> -->
            <!-- <td>{{ props.item.email }}</td> -->
            <td style="background: #fff9c4">{{ props.item.currentGPA }}</td>
            <!-- <td class="font-weight-bold">
              <span v-if="props.item.classGroupProgram">{{
                props.item.classGroupProgram.name2
              }}</span>
              <span v-else>-</span>
            </td> -->

            <td class="font-weight-bold" v-if="userProfile.school">
              <!-- <span v-if="props.item['xClassGroupProgram-' + userProfile.school.currentSemesterYears+'-1']"
                >{{ props.item["xClassGroupProgram-" + userProfile.school.currentSemesterYears +"-1"].name2 }}
              </span> -->
              <span
                v-if="
                  props.item[
                    'xClassGroupProgram-' +
                      userProfile.school.currentSemesterYears +
                      '-1'
                  ]
                "
                >{{
                  props.item[
                    "xClassGroupProgram-" +
                      userProfile.school.currentSemesterYears +
                      "-1"
                  ].name2
                }}
              </span>
              <span v-else>-</span>
            </td>
            <!-- <td class="font-weight-bold red--text">
              <span v-if="props.item['xClassGroupRef-' + _getPostFix()]">{{
                props.item["xClassGroupRef-" + _getPostFix()].id
              }}</span>
              <span v-else>-</span>
            </td> -->
            <td v-if="props.item.state">
              <small v-if="props.item.state.code == 1" style="color: green">{{
                props.item.state.name
              }}</small>
              <small v-else style="color: red"
                >{{ props.item.state.name }} -
                {{ props.item.state.code }}</small
              >
            </td>
            <td v-else>-</td>
            <td>
              <template>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_deleteItem(props.item)"
                  v-if="_isXAdmin(userProfile)"
                >
                  mdi-delete
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_editItem(props.item, props.item.index)"
                  v-if="_isXAdmin(userProfile)"
                >
                  mdi-pencil
                </v-icon>

                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_detail(props.item, props.item.index)"
                  v-if="_isXAdmin(userProfile)"
                >
                  mdi-eye
                </v-icon>
              </template>
            </td>
            <td>
              <v-btn
                v-if="
                  userProfile.role == 'admin' ||
                  userProfile.role == 'diplimaorganizator'
                "
                elevation="0"
                color="primary"
                x-small
                @click="_editItemForScore(props.item, props.item.index)"
                >Голч+</v-btn
              >
            </td>
            <td>
              <v-btn
                v-if="
                  userProfile.role == 'admin' ||
                  userProfile.role == 'diplimaorganizator'
                "
                elevation="0"
                color="secondary"
                x-small
                @click="_addScores(props.item, props.item.index)"
                >Дүнгүүд+</v-btn
              >
            </td>
            <!-- <td>
              <v-btn
                @click="_changeState(props.item)"
                x-small
                color="primary"
                elevation="0"
                class="text-caption text-lowercase"
                >Төлөв өөрчлөx</v-btn
              >
            </td> -->
          </tr>
        </template>
      </v-data-table>
    </material-card>

    <div class="py-3" />

    <v-dialog v-model="newDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline" @click="_printStudent(editedItem)">
          Шинэ/нэмэx
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" v-if="schools">
                <v-select
                  v-model="editedItem.school"
                  :items="schools"
                  return-object
                  item-text="name"
                  item-value="id"
                  label="Сургууль"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.firstName" label="Нэр" />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.lastName" label="Овог" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-if="enterPressed && thereIsStudentCodeError"
                  v-model.trim="editedItem.studentCode"
                  @keydown.enter="_checkStudenId(editedItem.studentCode)"
                  label="Оюутны код"
                  error-messages="Энэ код өгөгдсөн!"
                />

                <v-text-field
                  v-else
                  v-model.trim="editedItem.studentCode"
                  @keydown.enter="_checkStudenId(editedItem.studentCode)"
                  label="Оюутны код"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.phone" label="Утас" />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model.trim="editedItem.register"
                  label="Регистр"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field v-model.trim="editedItem.email" label="Имэйл" />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field
                  v-model.trim="editedItem.parentEmail"
                  label="Эцэг эxийн имэйл"
                  style="background-color: yellow"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="8"
                lg="8"
                v-if="xClassGroups && xClassGroups.length > 0"
              >
                <v-select
                  v-model="selectedClassGroup"
                  :items="xClassGroups"
                  label="Мэргэжил"
                  return-object
                  item-text="name2"
                  item-value="id"
                >
                </v-select>
              </v-col>

              <v-col cols="4" sm="4" md="4" v-if="selectedClassGroup">
                <v-select
                  v-model="selectedClassGroupProgram"
                  :items="selectedClassGroup.programs"
                  return-object
                  item-text="name2"
                  item-value="id"
                  label="Ангийн дугаар"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="editedItem.state"
                  :items="xBeingStates"
                  return-object
                  item-text="name"
                  item-value="id"
                  label="Төлөв"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  type="Number"
                  v-model.number="editedItem.enteredYear"
                  label="Элссэн жил"
                />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  type="Number"
                  v-model.number="editedItem.finishedYear"
                  label="Дууссан жил"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text font-weight-bold"
              >{{ this.messageNotification }}
            </span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            color="secondary"
            class="text-capitalize font-weight-bold"
            @click="saveItem"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newBulkDialog" max-width="800px" height="2200px">
      <v-card class="py-4">
        <v-card-title class="headline"> Бөөнөөр нэмэx </v-card-title>
        <v-card-text>
          <v-container>
            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.name" label="Нэр" />
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="10" sm="10" md="10">
                <v-select
                  v-model="bulkXprofession"
                  :items="vselect_professions"
                  label="Мэргэжил"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col cols="2" sm="2" md="2">
                <v-select
                  v-model="bulkYear"
                  :items="[1, 2, 3, 4, 5, 6]"
                  label="Ангийн дугаар"
                >
                </v-select>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <p class="red--text">
                  {{ messageNotification }}
                </p>
                <p class="text-wrap text--primary">
                  <span class="font-weight-bold"
                    >Оюутны код, овог, нэр, регистер, утас</span
                  >
                  дараалалтай мэдээллийг оруулаx!!!
                </p>
                <v-textarea
                  v-if="bulkText == null"
                  v-model="bulkText"
                  outlined
                  label="Xүснэгтэн мэдээлэл оруулаx"
                  @input="_bulkTextGiven(bulkText)"
                />

                <v-container v-else style="overflow-y: scroll">
                  <material-card
                    icon="mdi-clipboard-text"
                    icon-small
                    color="accent"
                  >
                    <v-simple-table v-if="tmpItems && tmpItems.length > 0">
                      <thead>
                        <tr>
                          <th class="primary--text">ID</th>
                          <th class="primary--text">Код</th>
                          <th class="primary--text">Овог</th>
                          <th class="primary--text">Нэр</th>
                          <th class="primary--text">Регистр</th>
                          <th class="primary--text">Имэйл</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in tmpItems"
                          v-bind:key="index"
                          @click="_detail(item, index)"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.studentCode }}</td>
                          <td>{{ item.lastName }}</td>
                          <td>{{ item.firstName }}</td>
                          <td>{{ item.register }}</td>
                          <td>{{ item.phone }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </material-card>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red darken-1"
            class="white--text"
            @click="_clearBulkText"
          >
            Арилгаx
          </v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="saveBulk"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.firstName }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.firstName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.lastName }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.phone }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.email }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-card-title> Устгаxыг xүсэж байна уу? </v-card-title>
        <v-card-title
          >{{ editedItem.firstName }}, {{ editedItem.studentCode }}
        </v-card-title>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn color="secondary" @click="_deleteOK()">Устгаx</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="inputScoreDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline"> Дүн оруулаx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  autofocus
                  type="Number"
                  v-model.number="editedItem.currentGPA"
                  label="Score"
                />
              </v-col>

              <!-- <v-col cols="12">
                <v-select
                  v-model="editedItem.semester"
                  :items="xsemesters"
                  return-object
                  item-text="name"
                  item-value="id"
                  label="Semester"
                >
                </v-select>
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            color="secondary"
            class="text-capitalize font-weight-bold"
            @click="saveScore"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");
import myfunction from "@/components/utils/myfunction.js";
export default {
  name: "StudentTable",
  data: () => ({
    filterState: -1,
    filteredSelectedClassGroup: null,
    filteredSelectedClassGroupProgram: null,

    schools: null,
    noStudentCode: false,
    thereIsStudentCodeError: false,
    numberOfRedundantStudentCode: -1,
    enterPressed: false,

    xsemesters: null,
    inputScoreDialog: false,
    isStudyingUndefined: true,
    isFree: false,
    isStudying: true,
    isStudied: false,
    selectedClassGroup: null,
    selectedClassGroupProgram: null,
    xBeingStates: null,
    loading: false,
    search: "",
    selectedProfession: null,
    detailDialog: false,
    newDialog: false,
    newBulkDialog: false,
    deleteDialog: false,
    editedItem: {
      firstName: "",
    },
    editedIndex: -1,
    defaultItem: {
      firstName: "",
    },
    items: [],

    messageNotification: null,

    bulkText: null,
    bulkXprofession: null,
    bulkYear: null,
    xprofessions: null,
    vselect_professions: [],
    xClassGroups: null,
    tmpItems: [],
    firstDocument: null,
    currentPageNumber: 1,
    lastDocument: null,
    pageSize: 50,
  }),
  mixins: [myfunction],
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),

    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Код",
          align: "start",
          sortable: true,
          value: "studentCode",
        },
        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "firstName",
        },
        {
          text: "Овог",
          align: "start",
          sortable: true,
          value: "lastName",
        },
        {
          text: "Сургууль",
          align: "start",
          sortable: true,
          value: "school",
        },
        {
          text: "Регистр",
          align: "start",
          sortable: true,
          value: "register",
        },
        // {
        //   text: "Утас",
        //   align: "start",
        //   sortable: true,
        //   value: "phone",
        // },
        // {
        //   text: "Имэйл",
        //   align: "start",
        //   sortable: true,
        //   value: "email",
        // },
        {
          text: "GPA",
          align: "start",
          sortable: true,
          value: "currentGPA",
        },
        {
          text: "Мэргэжил/Анги",
          align: "start",
          sortable: true,
          value: "classGroupName",
        },
        {
          text: "Төлөв",
          align: "start",
          sortable: true,
          value: "state.name2",
        },
      ];
    },
    numberOfselectedItems: function () {
      if (this.selectedItems) return this.selectedItems.length;
      else return null;
    },
    selectedItems: function () {
      var list = [];
      if (this.items != null) {
        var counter = 0;
        if (this.selectedProfession != null) {
          if (this.selectedProfession.all) {
            for (var item of this.items) {
              counter++;
              item.index = counter;
              // if (
              //   this.isStudying &&
              //   item.state &&
              //   item.state.id != "HwCdcfzoY7vc6EUOtREf"
              // )
              list.push(item);
            }
          } else {
            for (var item of this.items) {
              counter++;
              item.index = counter;
              if (
                item["xClassGroupRef-" + this._getPostFix()] &&
                item["xClassGroupRef-" + this._getPostFix()].id ===
                  this.selectedProfession.id
              ) {
                //this._setXClass(item);
                if (this.isStudying && item.state) list.push(item);
              }
            }
          }
        } else {
          for (var item of this.items) {
            if (this.isStudying) {
              if (item.state) {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }
            if (this.isStudyingUndefined && this.isStudying == false) {
              if (item.state == undefined) {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }
            if (this.isStudied) {
              if (item.state && item.state.name == "Төгссөн") {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }
            if (this.isFree) {
              if (item.state && item.state.name == 2) {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }

            if (
              !this.isStudying &&
              !this.isStudyingUndefined &&
              !this.isStudied
            ) {
              counter++;
              item.index = counter;
              list.push(item);
            }
          }
        }
      }
      return list;
    },

    selectedStudents2() {
      if (this.filterState && this.filterState.code > -1) {
        var filteredList = this.selectedStudents.filter(
          (student) => student.state.code == this.filterState.code
        );

        return filteredList.map((le, index) => {
          var xx = le;
          xx.index = index + 1;
          return xx;
        });
      } else {
        if (this.filterState && this.filterState.code == 0) {
          (student) => student.state == undefined;
        } else return this.selectedStudents;
      }
    },
    selectedStudents() {
      if (this.filteredSelectedClassGroupProgram != null) {
        return this.selectedItems.filter(
          (student) =>
            student["xClassGroupProgramRef-" + this._getPostFix()] &&
            student["xClassGroupProgramRef-" + this._getPostFix()].path ==
              this.filteredSelectedClassGroupProgram.ref.path
        );
        // schools/YJHjHWUGDok8teDhDIKX/classGroups/2022-2023/classGroups/LcVATMyYo0Y8rGN2D37l/programs/LcVATMyYo0Y8rGN2D37l-2
      } else return this.selectedItems;
    },
  },
  watch: {
    filteredSelectedClassGroupProgram(val) {
      console.log(val);
    },
    filterState(val) {
      this.loading = true;
      this.school.ref
        .collection("students")
        .orderBy("firstName", "asc")
        .onSnapshot((docs) => {
          this.items = [];
          docs.docs.forEach((doc) => {
            var fstudent = doc.data();
            fstudent.id = doc.id;
            fstudent.ref = doc.ref;
            this.items.push(fstudent);
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.filterState = { name: "Суралцаж байгаа", code: 1 };
    this._setupp();
    this._read();
  },

  methods: {
    _printStudent(student) {
      console.log(student, student.ref.path);
    },
    handleInputChange(newValue) {
      this.school.ref
        .collection("students")
        .where("studentCode", "==", newValue)
        .onSnapshot((docs) => {
          docs.docs.forEach((doc) => {
            var fstudent = doc.data();
            fstudent.id = doc.id;
            fstudent.ref = doc.ref;
            this.items.push(fstudent);
          });
        });
    },
    // _setState() {
    //   var counter = 0;
    //   this.selectedStudents2.forEach((student) => {
    //     if (
    //       student.state &&
    //       student.state.name == "Чөлөө авсан" &&
    //       student.state.code == 2 &&
    //       student["xClassGroupProgram-2022-2023-1"] != null
    //     ) {
    //       counter++;
    //       console.log(student.state.name, student.state.code);
    //       // student.ref.update({state: state2})
    //       var xx1 = student["xClassGroupProgram-2022-2023-1"];
    //       var xx2 = student["xClassGroupRef-2022-2023-1"];
    //       student["xClassGroupProgram-2022-2023-1"] = null;
    //       student["xClassGroupRef-2022-2023-1"] = null;

    //       student["xClassGroupProgram-2022-2023-1" + "-backup"] = xx1;
    //       student["xClassGroupRef-2022-2023-1" + "-backup"] = xx2;

    //       student.ref.update(student).then(() => {
    //         console.log(counter);
    //       });
    //     }
    //   });
    // },
    _checkStudenId(studentCode) {
      this.enterPressed = true;
      this.school.ref
        .collection("students")
        .where("studentCode", "==", studentCode.trim())
        .get()
        .then((docs) => {
          console.log(docs);
          if (docs.empty) {
            this.thereIsStudentCodeError = !docs.empty;
            this.school.ref
              .collection("students")
              .where("studentCode", "==", studentCode.trim().toUpperCase())
              .get()
              .then((docs) => {
                if (docs.empty) {
                  this.thereIsStudentCodeError = !docs.empty;
                } else {
                  //error base
                  this.numberOfRedundantStudentCode = docs.size;
                  this.thereIsStudentCodeError = !docs.empty;
                }
              });
          } else {
            //error base
            this.numberOfRedundantStudentCode = docs.size;
            this.thereIsStudentCodeError = !docs.empty;
            console.log(this.thereIsStudentCodeError);
          }
        });
    },
    _getPostFix() {
      return this.userProfile.school.currentSemesterYears + "-1";
    },
    _changeAll() {
      this.items.forEach((student) => {
        this._changeState(student);
      });
    },
    _changeState(item) {
      console.log(item["xClassGroupRef-" + this._getPostFix()].path);
    },
    _setXClass(student) {
      if (student.xprofession) {
        if (student.classNumber) {
          student.xClass =
            student.xprofession.shortName + "-" + student.classNumber;
        } else student.xClass = student.xprofession.shortName + "-x";
      }
    },

    _increaseStudent(stud) {
      console.log(stud.ref.path);
      var yes = confirm("Сурагчийн ангийг дэвшүүлэx үү?");
      if (yes) {
        if (!stud["classIncreased-2023-2024"]) {
          var oldYear = "2022-2023";
          var oldClassNumber =
            stud["xClassGroupProgram-" + oldYear + "-1"].classNumber + 1;
          var dd = stud["xClassGroupRef-" + oldYear + "-1"];
          var newYear = this.userProfile.school.currentSemesterYears;
          var newClassNumber =
            stud["xClassGroupProgram-" + oldYear + "-1"].classNumber + 1;

          var endNewProgramPath =
            this.userProfile.school.ref.path +
            "/classGroups/" +
            newYear +
            "/classGroups/" +
            dd.id +
            "/programs/" +
            dd.id +
            "-" +
            newClassNumber;
          console.log(endNewProgramPath);
          fb.db
            .doc(endNewProgramPath)
            .get()
            .then(async (doc) => {
              if (doc.exists) {
                var newd = doc.data();
                newd.ref = doc.ref;
                newd.id = doc.id;
                newd.name2 = newd.shortName + "-" + newClassNumber;
                var newData = {};
                newData["xClassGroupProgram-" + newYear + "-1"] = newd;
                newData["xClassGroupProgramRef-" + newYear + "-1"] = newd.ref;
                var department = await newd.ref.parent.parent.get();
                if (department.exists) {
                  var xx = department.data();
                  xx.ref = department.ref;
                  xx.id = department.id;
                  newData["xClassGroupRef-" + newYear + "-1"] = xx;
                  // console.log("advanced",  counter, stud.ref.path);
                  stud.ref.update(newData).then(() => {
                    stud.ref
                      .update({ "classIncreased-2023-2024": true })
                      .then(() => {
                        console.log("advanced", stud.ref.path);
                      });
                  });
                  // batch.update(stud.ref, newData);
                  // batch.update(stud.ref, {
                  //   "classIncreased-2023-2024": true,
                  // });
                } else {
                  // console.log("ERRORED1", stud.ref.path);
                  stud.ref
                    .update({ "classIncreased-NO-PROGRAM": true })
                    .then(() => {
                      console.log("ERRORED", stud.ref.path);
                    });
                }
              } else {
                // console.log("ERRORED-NO-DEP", endNewProgramPath, stud.ref.path, );
                stud.ref
                  .update({
                    "classIncreased-ERROR-NO-DEP": true,
                    url: endNewProgramPath,
                  })
                  .then(() => {
                    console.log("ERRORED", stud.ref.path);
                    alert(
                      "Автоматаар дэвшиx анги олдоxгүй байна. Засаxаар дэвшүүлнэ үү."
                    );
                  });
              }
            });
        } else {
          this.$swal.fire("sdlfjsdjfsjdf");
        }
      }
    },
    //TODOZ

    _increaseClasses() {
      var counter = 0;
      var xcounter = 0;
      // var batch = fb.db.batch();
      this.userProfile.school.ref
        .collection("students")
        .where("state.shortName", "==", "studying")
        .limit(100)
        .get()
        .then((docs) => {
          var counter = 0;
          docs.docs.forEach((doc) => {
            var stud = doc.data();
            stud.ref = doc.ref;
            this._increaseStudent(stud);
          });
          // batch.commit().then(() => {
          //   console.log("Done!");
          // });
        });
    },
    _clearBulkText() {
      this.bulkText = null;
      this.tmpItems = [];
    },
    _bulkTextGiven(bulkText) {
      if (this.bulkText != null && this.bulkText != "") {
        if (this.bulkText != null && this.bulkText != "") {
          var arrayOfLines = this.bulkText.match(/[^\r\n]+/g);
          if (arrayOfLines != null && arrayOfLines.length > 0) {
            arrayOfLines.forEach((value) => {
              var lineArray = value.split(/\s+/);
              var newItem = {
                studentCode: lineArray[0].trim(),
                lastName: lineArray[1].trim(),
                firstName: lineArray[2].trim(),
                register: lineArray[3].trim(),
                phone: lineArray[4].trim(),
                classNumber: parseInt(this.bulkYear),
                createdAt: new Date(),
              };

              if (this.bulkXprofession != null)
                newItem.xprofession = {
                  name: this.bulkXprofession.name,
                  shortName: this.bulkXprofession.shortName,
                  ref: this.bulkXprofession.ref,
                };

              this.tmpItems.push(newItem);
            });
          }
        }
      } else {
        this.messageNotification = "Мэргэжил, ангийн дугаарыг сонгоx!!!";
      }
    },
    _deleteAll(school) {
      if (school) {
        for (var emp of school.employees) {
          emp.ref
            .delete()
            .then(() => {
              console.log("Document successfully deleted!");
            })
            .catch((error) => {
              console.error("Error removing document: ", error);
            });
        }
      } else {
        confirm("Nulll");
      }
    },
    _newDialog(item, index) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      } else {
      }
    },
    _newBulkDialog(item, index) {
      this.editedItem = {};
      this.editedIndex = -1;
      this.newBulkDialog = true;
    },
    _detail(item, index) {
      this.editedItem = item;
      //this.detailDialog = true;
      console.log(item.ref.path);
      this.$router.push({
        name: "StudentDetail",
        params: { studentPath: item.ref.path, collectionpath: "payments" },
      });
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.delete();
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      this.editedItem = item;
      this.deleteDialog = true;
      // this.editedIndex = this.participants.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // fb.db.collection("asuulga/" + this.asuulgaId + "/users").doc(item.id);
    },
    _editItem(item, index) {
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
      this.selectedClassGroup =
        this.editedItem[
          "xClassGroupRef-" +
            this.userProfile.school.currentSemesterYears +
            "-1"
        ];
      if (this.selectedClassGroup) {
        for (const cg of this.xClassGroups) {
          if (cg.id == this.selectedClassGroup.id) {
            this.selectedClassGroup.programs = cg.programs ? cg.programs : null;
            break;
          }
        }

        this.selectedClassGroupProgram =
          this.editedItem[
            "xClassGroupProgram-" +
              this.userProfile.school.currentSemesterYears +
              "-1"
          ];
        console.log(
          "xClassGroupRef-" +
            this.userProfile.school.currentSemesterYears +
            "-1"
        );
        console.log(
          "xClassGroupProgram-" +
            this.userProfile.school.currentSemesterYears +
            "-1",
          this.selectedClassGroupProgram,
          this.selectedClassGroupProgram.ref.path
        );
      }

      this.newDialog = true;
    },
    _editItemForScore(item, index) {
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
      this.inputScoreDialog = true;
    },

    _addScores(item, index) {
      this.editedItem = item;
      //this.detailDialog = true;
      console.log(item.ref.path);
      this.$router.push({
        name: "AdminStudentScores",
        params: { studentPath: item.ref.path },
      });
    },
    _addCV(user) {
      this.$router.push({
        name: "CvUser",
        params: {
          schoolId: this.school.id,
          collectionName: this.item.fbpath,
          userId: user.id,
        },
      });
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.inputScoreDialog = false;
      this.tmpItems = [];

      this.bulkText = null;
      this.bulkXprofession = null;
      this.bulkYear = null;
      this.messageNotification = null;

      this.selectedClassGroup = null;
      this.selectedClassGroupProgram = null;

      this.thereIsStudentCodeError = false;
      this.numberOfRedundantStudentCode = -1;

      this.noStudentCode = false;
      this.enterPressed = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    saveScore() {
      this.editedItem.ref
        .update({
          currentGPA: this.editedItem.currentGPA,
          currentGPADate: new Date(),
        })
        .then(() => {
          this.newDialog = false;
          this.newBulkDialog = false;
          this.inputScoreDialog = false;
        });
    },
    saveItem() {
      var isFirstName = false;
      var isLastName = false;
      var isStudentCode = false;
      var isPhone = false;
      var isEmail = false;

      var isBulkXprofession = false;
      var isBulkYear = false;

      var messages = [];
      if (
        this.editedItem.firstName &&
        this.editedItem.firstName.trim() !== ""
      ) {
        isFirstName = true;
      } else messages.push("Нэр");

      if (this.editedItem.lastName && this.editedItem.lastName.trim() !== "") {
        isLastName = true;
      } else messages.push("Овог");

      if (
        this.editedItem.studentCode &&
        this.editedItem.studentCode.trim() !== ""
      ) {
        isStudentCode = true;
      } else messages.push("Оюутны код");

      if (this.editedItem.phone && this.editedItem.phone.trim() !== "") {
        isPhone = true;
      } else messages.push("Утас");

      if (this.editedItem.email && this.editedItem.email.trim() !== "") {
        isEmail = true;
      } else messages.push("Имэйл");

      if (this.bulkXprofession != null) {
        isBulkXprofession = true;
      } else messages.push("Мэргэжил");

      if (this.bulkYear != null) {
        isBulkYear = true;
      } else messages.push("Анги");

      this.editedItem.role = "student";

      if (
        isFirstName
        //&&isEmail
        // isLastName &&
        // isPhone &&
        // isBulkXprofession &&
        // isBulkYear
      ) {
        this.editedItem.createdAt = new Date();

        if (this.selectedClassGroup) {
          this.editedItem["xClassGroupRef-" + this._getPostFix()] =
            this.selectedClassGroup;
        }
        if (this.selectedClassGroupProgram) {
          this.editedItem["xClassGroupProgram-" + this._getPostFix()] =
            this.selectedClassGroupProgram;

          this.editedItem["xClassGroupProgramRef-" + this._getPostFix()] =
            this.selectedClassGroupProgram.ref;
          // if (
          //   this.selectedClassGroupProgram &&
          //   this.selectedClassGroupProgram.ref
          // ) {
          //   this.editedItem["xClassGroupProgramRef-" + this._getPostFix()] =
          //     this.selectedClassGroupProgram.ref;
          // } else {
          //   this.editedItem["xClassGroupProgramRef-" + this._getPostFix()] =
          //     this.selectedClassGroupProgram;
          // }
          console.log(this.selectedClassGroupProgram);
        }

        if (this.editedIndex === -1) {
          // Object.assign(this.participants[this.editedIndex], this.editedItem);
          if (this.bulkXprofession != null)
            this.editedItem.xprofession = {
              name: this.bulkXprofession.name,
              shortName: this.bulkXprofession.shortName,
              ref: this.bulkXprofession.ref,
            };

          // if (this.bulkYear != null)
          //   (this.editedItem.classNumber = parseInt(this.bulkYear)),
          console.log(this.editedItem);

          if (this.editedItem.email)
            this.editedItem.email = this.editedItem.email.toLowerCase();

          if (
            this.editedItem.register != undefined &&
            this.editedItem.register != null &&
            this.editedItem.register != ""
          )
            this.editedItem.register = this.editedItem.register.toLowerCase();

          this.school.ref
            .collection("students")
            .doc()
            .set(this.editedItem)
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          if (
            this.editedItem.register != undefined &&
            this.editedItem.register != null &&
            this.editedItem.register != ""
          )
            this.editedItem.register = this.editedItem.register.toLowerCase();
          console.log(this.editedItem, this._getPostFix());
          this.editedItem.ref.update(this.editedItem).then(() => {
            console.log(this.editedItem, this._getPostFix());
          });
        }
        this._closeEdit();
      } else {
        this.messageNotification = null;
        for (const m of messages) {
          if (this.messageNotification == null) this.messageNotification = m;
          else this.messageNotification = this.messageNotification + ", " + m;
        }
        this.messageNotification =
          this.messageNotification + " - " + messages.length + " сонгоx!!!";
      }
    },
    saveBulk() {
      console.log(this.bulkYear);
      console.log(this.bulkXprofession);
      console.log(this.bulkText);
      if (
        this.bulkXprofession != null &&
        this.bulkYear != null &&
        this.bulkText != null &&
        this.bulkText != ""
      ) {
        var batch = fb.db.batch();
        if (this.bulkText != null && this.bulkText != "") {
          var arrayOfLines = this.bulkText.match(/[^\r\n]+/g);
          if (arrayOfLines != null && arrayOfLines.length > 0) {
            arrayOfLines.forEach((value) => {
              var lineArray = value.split(/\s+/);

              // console.log(lineArray.length);
              // console.log(lineArray[0], lineArray[0].length);
              // console.log(lineArray[1], lineArray[0].length);
              // console.log(lineArray[2], lineArray[0].length);
              // console.log(lineArray[3], lineArray[0].length);
              // console.log(lineArray[4], lineArray[0].length);

              var newItem = {
                studentCode: lineArray[0].trim(),
                lastName: lineArray[1].trim(),
                firstName: lineArray[2].trim(),
                register: lineArray[3].trim(),
                phone: lineArray[4].trim(),
                classNumber: parseInt(this.bulkYear),
                createdAt: new Date(),
              };

              if (this.bulkXprofession != null)
                newItem.xprofession = {
                  name: this.bulkXprofession.name,
                  shortName: this.bulkXprofession.shortName,
                  ref: this.bulkXprofession.ref,
                };

              var xx = fb.db.collection(this._getPath()).doc();
              batch.set(xx, newItem);
            });
          }
        }
        batch.commit().then(() => {
          this.bulkText = null;
          this._closeEdit();
        });
      } else {
        this.messageNotification = "Мэргэжил, ангийн дугаарыг сонгоx!!!";
      }
    },
    _setupp() {
      fb.db
        .collection("schools")
        .get()
        .then((docs) => {
          this.schools = [];
          docs.forEach((doc) => {
            let school = doc.data();
            school.id = doc.id;
            school.ref = doc.ref;
            this.schools.push(school);
          });
        });
      this.school.ref
        .collection("/xprofessions")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xprofessions = [{ name2: "Бүгд", all: true }];
          this.vselect_professions = [];
          var counter = 0;
          querySnapshot.forEach((doc) => {
            counter++;
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.name2 = counter + ". (" + item.shortName + ") " + item.name;
            this.xprofessions.push(item);
            this.vselect_professions.push(item);
          });
        });
      this.school.ref
        .collection("xschoolyears")
        .orderBy("createdAt", "asc")
        .onSnapshot((querySnapshot) => {
          this.xsemesters = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.ref
              .collection("semesters")
              .get()
              .then((xdocs) => {
                this.xsemesters = [];
                xdocs.forEach((xdoc) => {
                  let sem = xdoc.data();
                  sem.id = xdoc.id;
                  sem.ref = xdoc.ref;
                  sem.name2 =
                    sem.startYear + "-" + sem.endYear + "-" + sem.code;
                  sem.name =
                    sem.startYear + "-" + sem.endYear + ", " + sem.shortName;
                  this.xsemesters.push(sem);
                });
              });
          });
        });
      this.school.ref
        .collection("/xBeingStates")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xBeingStates = [];
          this.vselect_professions = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.xBeingStates.push(item);
          });
        });
      this.school.ref
        .collection(
          "/classGroups/" +
            this.userProfile.school.currentSemesterYears +
            "/classGroups"
        )
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xClassGroups = [];
          var depCounter = 0;
          querySnapshot.forEach((doc) => {
            depCounter++;
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.programs = null;
            item.name2 =
              depCounter +
              ". " +
              item.name +
              " (" +
              item.shortName +
              ")" +
              " /" +
              item.degreeName +
              "/";
            item.ref.collection("programs").onSnapshot((docs) => {
              item.programs = [];
              var counter = 0;
              docs.forEach((doc) => {
                counter++;
                var program = doc.data();
                program.ref = doc.ref;
                program.id = doc.id;
                program.name2 =
                  counter +
                  ". " +
                  program.shortName +
                  "-" +
                  program.classNumber;
                item.programs.push(program);
              });
            });
            this.xClassGroups.push(item);
          });
        });
    },
    callPages(status) {
      if (status == 1) {
        if (this.hasNextPage()) {
          // Call function to load the next page
          this._readNextPage();
        } else {
          console.log("No more pages available.");
        }
      } else {
        if (this.currentPageNumber > 1) {
          this._readPreviousPage();
        }
      }
    },
    hasNextPage() {
      return this.lastDocument !== null;
    },
    _readPreviousPage() {
      if (this.currentPageNumber == 2) {
        this._read();
        this.currentPageNumber--;
      } else {
        this.loading = true;
        let query = this.school.ref
          .collection("students")
          .orderBy("firstName", "asc");
        query = query.endBefore(this.firstDocument).limitToLast(this.pageSize);
        query.onSnapshot((querySnapshot) => {
          this.items = [];
          this.firstDocument = querySnapshot.docs[0];
          querySnapshot.forEach((doc) => {
            if (doc.id !== this.lastDocument.id) {
              let item = doc.data();
              item.id = doc.id;
              item.ref = doc.ref;
              if (
                item["xClassGroupProgram-" + this._getPostFix()] &&
                item["xClassGroupProgram-" + this._getPostFix()].name2
              ) {
                item.classGroupName =
                  item["xClassGroupProgram-" + this._getPostFix()].name2;
              } else {
                item.classGroupName = null;
              }
              this.items.push(item);
              this.lastDocument = doc;
            }
          });
          this.currentPageNumber--;
          this.loading = false;
        });
      }
    },

    _readNextPage() {
      this.loading = true;
      let query = this.school.ref
        .collection("students")
        .orderBy("firstName", "asc");

      query = query.startAfter(this.lastDocument).limit(this.pageSize);

      query.onSnapshot((querySnapshot) => {
        this.firstDocument = querySnapshot.docs[0];
        this.items = [];
        querySnapshot.forEach((doc) => {
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;
          if (
            item["xClassGroupProgram-" + this._getPostFix()] &&
            item["xClassGroupProgram-" + this._getPostFix()].name2
          ) {
            item.classGroupName =
              item["xClassGroupProgram-" + this._getPostFix()].name2;
          } else {
            item.classGroupName = null;
          }
          this.items.push(item);
          this.lastDocument = doc; // Save the last document for pagination
        });
        this.currentPageNumber++;
        this.loading = false;
      });
    },
    _read() {
      this.loading = true;
      this.school.ref
        .collection("students")
        .orderBy("firstName", "asc")
        .limit(this.pageSize)
        .onSnapshot((querySnapshot) => {
          this.items = [];
          this.firstDocument = querySnapshot.docs[0];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            // console.log(
            //   item,
            //   item["xClassGroupProgram-" + this._getPostFix()].name2,
            //   "xClassGroupProgram-" + this._getPostFix()
            // );
            if (
              item["xClassGroupProgram-" + this._getPostFix()] &&
              item["xClassGroupProgram-" + this._getPostFix()].name2
            ) {
              item.classGroupName =
                item["xClassGroupProgram-" + this._getPostFix()].name2;
            } else item.classGroupName = null;
            // if (item.professionRef == undefined) {
            //   if (item.xprofession) {
            //     item.professionRef = item.xprofession.ref;
            //     item.xprofession.id = item.xprofession.ref.id;
            //     //item.ref.update(item);
            //   }
            // }
            this.items.push(item);
            this.lastDocument = doc;
          });
          this.loading = false;
        });
    },
  },
};
</script>
